import {
    useContext,
} from 'react';

import {
    LiffProvider,
    LiffContext,
    LiffProviderValue,
} from './components';

export const useLiff = (): LiffProviderValue => useContext(LiffContext);

export { LiffProvider };
